function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { withEDSContext } from '../EDSContext/EDSContext';

var withPlatform = function withPlatform() {
    return function (WebComponent, MobileComponent) {
        var Wrap = React.forwardRef(function (props, ref) {
            var edsContext = props.edsContext,
                rest = _objectWithoutProperties(props, ['edsContext']);

            return React.createElement(
                React.Fragment,
                null,
                edsContext.platform === 'mobile' && React.createElement(MobileComponent, rest),
                (!edsContext.platform || edsContext.platform === 'web') && React.createElement(WebComponent, rest)
            );
        });

        return withEDSContext(Wrap);
    };
};

export default withPlatform;